import React from 'react';
import { useSelector } from 'react-redux';
import { t } from '../../../helpers/t';

export function ListingFAQ() {
  const { userLanguage } = useSelector((state) => state.env) || {};
  const lang = userLanguage || 'en';

  const howItWorksPath = lang === 'fr'
    ? 'https://www.thestorefront.com/fr/go/comment-ca-marche/'
    : 'https://www.thestorefront.com/go/how-it-works/';

  return (
    <div id="listing_faq" className="rounded p-4 bg-sky-50 border m-2 md:mx-0 md:border-l-4 border-solid border-sky-700 border-l-sky-700 md:mt-4">
      <div className="text-sky-700 text-xl font-medium">
        {t('listings.show.howItWorks.header')}
      </div>

      <ol className="text-sky-700 font-extralight">
        <li className="pb-2">{t('listings.show.howItWorks.steps.1')}</li>
        <li className="pb-2">{t('listings.show.howItWorks.steps.2')}</li>
        <li className="pb-2">{t('listings.show.howItWorks.steps.3')}</li>
      </ol>

      <a className="text-sky-700 underline underline-offset-2 decoration-1 font-normal" target="_blank" href={howItWorksPath} rel="noopener noreferrer">
        {t('listings.show.howItWorks.learn_more')}
      </a>
    </div>
  );
}
